/**
 * RegistrationSessions Store
 * Zustand store for managing registration sessions state
 */

import { create } from 'zustand';
import type { RegistrationSession } from '@/application/queries/registrationSessions/GetRegistrationSessionsQuery';

/**
 * Initial state values
 */
const initialState = {
  sessions: [] as RegistrationSession[],
  sessionsLoading: true,
  sessionsError: null as Error | null,
  retrying: false,
};

/**
 * Store state interface
 */
interface RegistrationSessionsState {
  sessions: RegistrationSession[];
  sessionsLoading: boolean;
  sessionsError: Error | null;
  retrying: boolean;

  // Actions
  setSessions: (sessions: RegistrationSession[]) => void;
  setSessionsLoading: (loading: boolean) => void;
  setSessionsError: (error: Error | null) => void;
  setRetrying: (retrying: boolean) => void;

  // For testing
  _reset: () => void;
}

/**
 * Zustand store for RegistrationSessions
 */
export const useRegistrationSessionsStore = create<RegistrationSessionsState>((set) => ({
  ...initialState,

  setSessions: (sessions) =>
    set({
      sessions,
      sessionsLoading: false,
      sessionsError: null,
    }),

  setSessionsLoading: (sessionsLoading) => set({ sessionsLoading }),

  setSessionsError: (sessionsError) => set({ sessionsError }),

  setRetrying: (retrying) => set({ retrying }),

  _reset: () => set(initialState),
}));
